import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import Api from '../Api'
import mixpanel from 'mixpanel-browser'
import moment from 'moment'
import { push } from 'connected-react-router'
import { actions as settingsActions } from './settings'

export const types = {
    LOG_OUT: 'WRAPPER/LOG_OUT',
    FETCH_ACCOUNTS: 'WRAPPER/FETCH_ACCOUNTS',
    SWITCH_ACCOUNT: 'WRAPPER/SWITCH_ACCOUNT',
    LOAD_DATA: 'WRAPPER/LOAD_DATA',
    START_UPDATE_TIMER: 'WRAPPER/START_UPDATE_TIMER',
    STOP_UPDATE_TIMER: 'WRAPPER/STOP_UPDATE_TIMER',
    SET_SETTINGS: 'WRAPPER/SET_SETTINGS',
    START_POLLING: 'WRAPPER/START_POLLING',
    CANCEL_PROBLEMATIC_POLLING: 'WRAPPER/CANCEL_PROBLEMATIC_POLLING',
}

export const actions = {
    logout: () => ({ type: types.LOG_OUT }),
    fetchAccounts: () => ({ type: types.FETCH_ACCOUNTS }),
    switchAccount: (accountId) => ({ type: types.SWITCH_ACCOUNT, accountId }),
    loadData: (data) => ({ type: types.LOAD_DATA, data }),
    startUpdateTimer: () => ({ type: types.START_UPDATE_TIMER }),
    stopUpdateTimer: () => ({ type: types.STOP_UPDATE_TIMER }),
    setSettings: (settings) => ({ type: types.SET_SETTINGS, settings }),
    startPolling: () => ({ type: types.START_POLLING }),
    cancelProblematicPolling: () => ({ type: types.CANCEL_PROBLEMATIC_POLLING }),
}

export const initialState = {
    accounts: [{ name: '' }],
    user: '',
    configurationUpdating: false,
    settings: {
        dont_show_configuration_updating_notice: false,
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.LOAD_DATA:
            return {
                ...state,
                configurationUpdating: moment().isBefore(action.data.settings.update_time),
                accounts: action.data.accounts,
                currentAccountIdx: action.data.current_account_idx,
                user: action.data.user,
                serial: action.data.serial,
                build: action.data.build,
                settings: {
                    ...action.data.settings,
                    update_time: moment(action.data.settings.update_time)
                }
            }
        case types.START_UPDATE_TIMER:
            return {
                ...state,
                configurationUpdating: true,
                settings: {
                    ...state.settings,
                    update_time: moment().add(5, 'minutes'),
                },
            }
        case types.STOP_UPDATE_TIMER:
            return {
                ...state,
                configurationUpdating: false,
            }
        default:
            return state
    }
}

/* Sagas */

export function* fetchAccounts(action) {
    try {
        const accountsRes = yield call(Api.fetchAccounts);
        mixpanel.register({
            AccountId: accountsRes.accounts[0].id,
            UserId: accountsRes.user_id,
            Email: accountsRes.user,
            Name: accountsRes.name,            
        });
        const settingsRes = yield call(Api.fetchSettings);
        yield put(settingsActions.load(settingsRes));
        yield put(actions.loadData({ ...accountsRes, settings: { ...settingsRes } }))
    } catch (e) {
    }
}

export function* switchAccount(action) {
    try {
        yield call(Api.switchAccount, action.accountId);
        yield put(push('/'))
        window.location.reload();
    } catch (e) {
    }
}

export function* setSettings(action) {
    try {
        yield call(Api.setSettings, { ...action.settings });
    } catch (e) {
    }
}

export function* startUpdateTimer(action) {
    try {
        const state = yield select();
        const settings = state.waas.wrapper.settings;
        yield call(Api.setSettings, { update_time: settings.update_time });
    } catch (e) {
    }
}


export function* logout(action) {
    try {
        yield call(Api.logout);
        yield put(push('/login'))
        mixpanel.track('LoggedOut');
    } catch (e) {
    }
}

export function* wrapperPageFlow() {
    yield takeLatest(types.FETCH_ACCOUNTS, fetchAccounts);
    yield takeLatest(types.LOG_OUT, logout);
    yield takeEvery(types.SET_SETTINGS, setSettings);
    yield takeEvery(types.SWITCH_ACCOUNT, switchAccount);
    yield takeEvery(types.START_UPDATE_TIMER, startUpdateTimer);
}